import { useGetExerciseTypesSearch } from '#api/exercise-types';
import { useDashboardCharFormExerciseState } from '#pages/DashboardChartForm/states/dashboardCharFormExerciseState';
import { Input } from '#shared/Input/Input';
import { useExercisePresetRecoil } from '#states/exercisePresetsState';
import { produce } from 'immer';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { SearchList } from './SearchList';
import { SetTypeChange } from './SetTypeChange';

interface ExerciseSearchProps {
  index: number;
  defaultExerciseKeyword?: string;
}

/**
 * @param index - 운동 리스트 인덱스
 * @param defaultExerciseKeyword - 이미 선택된 운동 이름
 * @returns
 */
export const ExerciseSearch = ({
  index,
  defaultExerciseKeyword
}: ExerciseSearchProps) => {
  const { pathname } = useLocation();
  const isSelectPresetPage = pathname.includes('/select-presets');

  // 운동 검색 키워드
  const [exerciseKeyword, setExerciseKeyword] = useState<string>(
    defaultExerciseKeyword || ''
  );

  // 운동 검색 리스트 표시 여부
  const [isOpenSearchList, setIsOpenSearchList] = useState<boolean>(
    defaultExerciseKeyword ? false : true
  );

  // 운동 검색 리스트
  const { data: exerciseList } = useGetExerciseTypesSearch({
    name: exerciseKeyword
  });

  // api에 추가할 프리셋 정보
  const { setExercisePresets } = useExercisePresetRecoil();

  const { setRecords } = useDashboardCharFormExerciseState();

  // 운동 이름으로 운동 타입 id 가져오기
  const getExerciseTypeId = (value: string) => {
    const exerciseTypeId = exerciseList?.find(
      exercise => exercise.name === value
    )?.id;

    return exerciseTypeId;
  };

  const onClick = (value: string) => {
    const exerciseTypeId = getExerciseTypeId(value);

    setExerciseKeyword(value);

    if (isSelectPresetPage) {
      setExercisePresets(
        produce(draft => {
          draft.exercisePresetWorkout[index].exerciseTypeId =
            exerciseTypeId || '';
        })
      );
    } else {
      setRecords(
        produce(draft => {
          if (draft && draft[index]) {
            // 배열과 인덱스가 유효한지 확인
            draft[index].exerciseTypeId = exerciseTypeId || '';
            draft[index].exerciseKind = value;
          }
        })
      );
    }
  };

  const onReset = () => {
    setExerciseKeyword('');

    if (isSelectPresetPage) {
      setExercisePresets(
        produce(draft => {
          draft.exercisePresetWorkout[index].exerciseTypeId = '';
        })
      );
    } else {
      setRecords(
        produce(draft => {
          if (draft && draft[index]) {
            // 배열과 인덱스가 유효한지 확인
            draft[index].exerciseTypeId = '';
            draft[index].exerciseKind = '';
          }
        })
      );
    }
  };

  useEffect(() => {
    if (defaultExerciseKeyword) {
      setExerciseKeyword(defaultExerciseKeyword);
    }
  }, [defaultExerciseKeyword]);

  return (
    <>
      <div className="flex gap-8 items-center">
        <Input
          onChange={e => {
            setExerciseKeyword(e.target.value);
            setIsOpenSearchList(true);
          }}
          value={exerciseKeyword}
          placeholder="운동 이름"
          onReset={onReset}
        />

        <SetTypeChange index={index} />
      </div>

      <div style={{ display: isOpenSearchList ? 'block' : 'none' }}>
        <SearchList
          onClick={value => {
            onClick(value);
            setIsOpenSearchList(false);
          }}
          exerciseKeyword={exerciseKeyword}
        />
      </div>
    </>
  );
};
